module.exports = __webpack_public_path__ + "img/icons8-realtime-100.710325f6.png";